const ACTION_LABELS: Record<string, string> = {
  allow: 'Allow',
  soft_block: 'Soft block',
  soft_block_profile: 'Soft block (profile)',
  remove: 'Remove',
  require_edit: 'Require edit',
  derank: 'Derank',
  label: 'Label',
  suspend: 'Suspend',
  ban: 'Ban',
  escalate: 'Escalate',
}

const CONTENT_TYPE_LABELS: Record<string, string> = {
  post: 'Posts',
  comment: 'Comments',
  profile: 'Profiles',
  listing: 'Listings',
  handle: 'Handles',
  dm: 'DMs',
  link: 'Links',
  other: 'Other',
}

const QUEUE_LABELS: Record<string, string> = {
  auto: 'Auto',
  human_review: 'Human review',
  urgent: 'Urgent',
}

function titleCase(input: string) {
  return input
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function mapActionKeyToLabel(key: string) {
  if (!key) return ''
  return ACTION_LABELS[key] || titleCase(key)
}

export function mapContentTypeToLabel(key: string) {
  if (!key) return ''
  return CONTENT_TYPE_LABELS[key] || titleCase(key)
}

export function mapQueueKeyToLabel(key: string) {
  if (!key) return ''
  return QUEUE_LABELS[key] || titleCase(key)
}
